import axios from 'axios'
import router from '../router'
// import versionUrl from '../script/versionToDistinguish'
// import qs from 'qs'
// import SiteDifferentialConfiguration from '../script/SiteDifferentialConfiguration'
import { Toast } from 'vant-green'
// let num = 0
// axios默认配置
const service = axios.create({
  baseURL: process.env.BASE_URL
})
//  request拦截器==>对请求参数做处理
service.interceptors.request.use(config => {
  config.headers['Authorization-ValidateType'] = 'web'
  config.headers['Authorization-Language'] = 'zh-Hans'
  config.headers['Authorization-RefSite'] = window.document.domain
  let token = window.localStorage.getItem('flagMig')
  if (!token) {
    router.push({path: '/login'})
  } else {
    config.headers['Authorization-Token'] = token
  }

  if (config.url.indexOf('AccountApi/WxLogin') !== -1) {
    config.headers['Authorization-Token'] = 'WxLogin'
  }
  config.method === 'post'
    ? config.data = {...config.data}
    : config.params = {...config.params}
  // if (config.Localloading === undefined) {
  //   startLoading()
  // } else if (config.Localloading !== 'has') {
  //   startLoading()
  // }
  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器==>对响应做处理
service.interceptors.response.use(
  response => {
    if (response.data.code !== 200 && response.data.code !== 301) {
      // Toast(response.data.message)
    }
    if (response.data.code === 301) {
      router.push({path: '/login'})
    }
    // endLoading()
    return response.data
  },
  error => {
    Toast('error!')
    // endLoading()
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/http/axios.js